import React from 'react';
import Skeleton from 'react-loading-skeleton';
import styles from './ProductMatching.module.scss';
import Container from '~/components/Container';

const ProductMatchingSkeleton = () => {
    return (
        <Container rootClassName={styles.shoes_matching_wrapper} className={styles.shoes_matching}>
            <Skeleton width={'100%'} height={32}></Skeleton>
            <div className="grid grid-cols-5 gap-4">
                {[...Array(10)].map((_, index) => (
                    <Skeleton containerClassName={styles.shoe_item} key={index} className="w-full" height={200} />
                ))}
            </div>
        </Container>
    );
};

export default ProductMatchingSkeleton;
